import { FC } from "react";
import classNames from "classnames";
import { ICasinoBet } from "@finbackoffice/clientbff-client";
import { AssetsDirectory, TranslationScopes } from "@finbackoffice/enums";
import Translate from "components/base/translate/Translate";
import { useDate, DEFAULT_DATE_FORMAT } from "hooks";
import { CurrencyFormatter } from "components/base/currency-formater/CurrencyFormater";
import { Svg } from "components/base/svg/Svg";
import styles from "../../sport/bet-row/sport-bet-row.module.sass";

interface Props {
    bet: ICasinoBet;
}

const CasinoBetRow: FC<Props> = ({ bet }) => {
    const { formatDate } = useDate();

    return (
        <div className={classNames(styles.bet, styles[`base-icon-${bet.status.toLowerCase()}`])}>
            <div>
                <span className={styles.label}>id:</span>
                <strong>{bet.short_id}</strong>
                <span className={styles.label}>
                    {formatDate(new Date(bet.created_at), `${DEFAULT_DATE_FORMAT} HH:mm`, false)}
                </span>
                <Svg
                    src={`/${AssetsDirectory.Common}/${AssetsDirectory.Mobile}/${AssetsDirectory.BaseIcons}/status-${bet.status.toLowerCase()}.svg`}
                    className="svg-icon"
                />
            </div>
            <div className={styles.game}>{`${bet.game_category} ${bet.game_type}`}</div>
            <div className={styles.info}>
                <p>{bet.game_name}</p>
                <p>
                    <span className={styles.label}>
                        <Translate
                            tid="account_bets_round"
                            namespace={TranslationScopes.UserAccount}
                        />
                        :
                    </span>
                    {bet.round_id}
                </p>
                {!!bet.free_round_id && (
                    <p>
                        <span className={styles.label}>
                            <Translate
                                tid="account_bets_promo_id"
                                namespace={TranslationScopes.UserAccount}
                            />
                            :
                        </span>
                        {bet.free_round_id}
                    </p>
                )}
            </div>
            <div>
                <p>
                    <span className={styles.label}>
                        <Translate
                            tid="account_bets_stake"
                            namespace={TranslationScopes.UserAccount}
                        />
                        :
                    </span>
                    <strong>
                        <CurrencyFormatter
                            currency={bet.session_casino_currency}
                            amount={bet.casino_stake_amount}
                            withCode={false}
                            withSymbol
                        />
                        {" / "}
                        <CurrencyFormatter
                            currency={bet.session_wallet_currency}
                            amount={bet.wallet_stake_amount}
                            withCode={false}
                            withSymbol
                        />
                    </strong>
                    <span className={styles.label}>
                        <Translate
                            tid="account_bets_result"
                            namespace={TranslationScopes.UserAccount}
                        />
                        :
                    </span>
                    <strong>
                        <CurrencyFormatter
                            currency={bet.session_casino_currency}
                            amount={bet.casino_result_amount}
                            withCode={false}
                            withSymbol
                        />
                        {" / "}
                        <CurrencyFormatter
                            currency={bet.session_wallet_currency}
                            amount={bet.wallet_result_amount}
                            withCode={false}
                            withSymbol
                        />
                    </strong>
                </p>
            </div>
        </div>
    );
};

export default CasinoBetRow;
